module.exports = "<router-outlet></router-outlet>\r\n<tis-foot></tis-foot>"


//////////////////
// WEBPACK FOOTER
// C:/carlos/wks/web/vacios_web/src/app/cse.body.html
// module id = ../../../../../src/app/cse.body.html
// module chunks = main